// Формат form_schema.conditions и правила проверки совпадают с lk_backend/lk_app/task_data_validation.py
// (form_conditions, form_conditions_errors): сервер повторяет проверку при отправке задания.
import { isFilledValue } from './analyteLimit';

export const CONDITIONS_KEY = 'conditions';

export const CONDITIONS_ACTOR_LAB = 'lab';
export const CONDITIONS_ACTOR_EXPERT = 'expert';
export const CONDITIONS_ACTOR_ALL = 'all';

export const REQUIRED_FIELD_ERROR = 'обязательное поле';

const CONDITION_ERROR_KEYWORD = 'formCondition';

export function linkedGroupError(groupName) {
  return `Нужно заполнить все поля аналита «${groupName}»`;
}

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

// Кто проверяется при отправке задания из кабинета.
export function conditionsActorForFormMode(formMode) {
  if (formMode === 'lab') return CONDITIONS_ACTOR_LAB;
  if (formMode === 'expert') return CONDITIONS_ACTOR_EXPERT;
  return CONDITIONS_ACTOR_ALL;
}

// Обязательные поля и связанные группы с полями, которые есть в properties.
export function getFormConditions(schema) {
  const empty = { requiredFields: [], linkedGroups: [] };
  if (!isPlainObject(schema)) return empty;
  const properties = schema.properties;
  const conditions = schema[CONDITIONS_KEY];
  if (!isPlainObject(properties) || !isPlainObject(conditions)) return empty;

  const knownFields = (names) =>
    Array.isArray(names)
      ? [...new Set(names.filter((name) => typeof name === 'string' && name in properties))]
      : [];

  const requiredFields = knownFields(conditions.required_fields);

  const rawGroups = Array.isArray(conditions.linked_groups) ? conditions.linked_groups : [];
  const linkedGroups = [];
  rawGroups.forEach((group, index) => {
    if (!isPlainObject(group)) return;
    const fields = knownFields(group.fields);
    if (fields.length < 2) return;
    const name =
      typeof group.name === 'string' && group.name.trim() ? group.name.trim() : `Группа ${index + 1}`;
    linkedGroups.push({ name, fields });
  });

  return { requiredFields, linkedGroups };
}

function filledBy(fieldSchema) {
  return (isPlainObject(fieldSchema) && fieldSchema.filled) || CONDITIONS_ACTOR_LAB;
}

export function linkedGroupSummaryError(groupName, fieldsCount) {
  return `Нужно заполнить все поля аналита "${groupName}". Число полей: ${fieldsCount}`;
}

// Незаполненные поля, которые должен заполнить actor:
// requiredFields — обязательные поля, linkedGroups — частично заполненные группы.
export function getFormConditionsViolations(schema, data, actor) {
  const { requiredFields, linkedGroups } = getFormConditions(schema);
  const violations = { requiredFields: [], linkedGroups: [] };
  if (requiredFields.length === 0 && linkedGroups.length === 0) return violations;

  const values = isPlainObject(data) ? data : {};
  const isFilled = (name) => isFilledValue(values[name]);
  const mustFill = (name) =>
    !isFilled(name) &&
    (actor === CONDITIONS_ACTOR_ALL || filledBy(schema.properties[name]) === actor);

  violations.requiredFields = requiredFields.filter(mustFill);
  for (const group of linkedGroups) {
    if (!group.fields.some(isFilled)) continue;
    const fields = group.fields.filter(mustFill);
    if (fields.length > 0) violations.linkedGroups.push({ name: group.name, fields });
  }
  return violations;
}

// Нарушения условий по полям: { имяПоля: сообщение } в порядке обнаружения.
export function getFormConditionsErrors(schema, data, actor) {
  return violationsToFieldErrors(getFormConditionsViolations(schema, data, actor));
}

export function violationsToFieldErrors({ requiredFields, linkedGroups }) {
  const errors = {};
  const addError = (name, message) => {
    if (!(name in errors)) errors[name] = message;
  };

  requiredFields.forEach((name) => addError(name, REQUIRED_FIELD_ERROR));
  for (const group of linkedGroups) {
    group.fields.forEach((name) => addError(name, linkedGroupError(group.name)));
  }
  return errors;
}

// Ошибки в формате AJV для additionalErrors JsonForms: показываются под полем.
export function toJsonFormsErrors(conditionsErrors) {
  return Object.entries(conditionsErrors).map(([name, message]) => ({
    instancePath: `/${name}`,
    schemaPath: `#/${CONDITIONS_KEY}`,
    keyword: CONDITION_ERROR_KEYWORD,
    params: {},
    message: message.charAt(0).toUpperCase() + message.slice(1),
  }));
}
